export const checkAuthorized = (requiredRole, userRoles) => {
  const authorized = userRoles?.includes(requiredRole);
  return authorized;
};
